import { render, staticRenderFns } from "./TestimonialsBlock.vue?vue&type=template&id=53443af9&scoped=true"
import script from "./TestimonialsBlock.vue?vue&type=script&lang=js"
export * from "./TestimonialsBlock.vue?vue&type=script&lang=js"
import style0 from "./TestimonialsBlock.vue?vue&type=style&index=0&id=53443af9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53443af9",
  null
  
)

export default component.exports